import { AxiosInstance } from "axios"
import { GenericResponse } from "."
import { UserModel } from "./user.api"

export interface WarehouseModel {
    id: number
    name: string
    country: string
    city: string
    address: string
    zip_code?: string
    phone: string
    active: boolean
    state: string
    address2?: string
    created_by: UserModel
    updated_by: UserModel
}

export interface CreateWarehouseRequest {
    name: string
    country: string
    city: string
    address: string
    zip_code?: string
    phone: string
    state: string
    address2?: string
    active: boolean
}

export interface UpdateWarehouseRequest {
    name?: string
    country?: string
    city?: string
    address?: string
    state: string
    zip_code?: string
    phone?: string
    address2?: string
    active?: boolean
}

const warehouseApi = (apiInstance: AxiosInstance) => {
    const warehousesList = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/warehouses/get-all-warehouses`)
        return res
    }

    const createWarehouse = async (newWarehouseData: CreateWarehouseRequest): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/warehouses/create-warehouse`, {
            warehouseData: newWarehouseData
        })
        return res
    }

    const updateWarehouse = async (existingWarehouseData: UpdateWarehouseRequest): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.put(`/warehouses/update-warehouse`, {
            warehouseData: existingWarehouseData
        })
        return res
    }

    const deleteWarehouse = async (warehouseId: number): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/warehouses/delete-unused-warehouse`, {
            id: warehouseId
        })
        return res
    }

    const markWarehouseAsDefault = async ({
        warehouseId,
        userId
    }: {
        warehouseId: number
        userId: number
    }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.put(`/warehouses/mark-warehouse-as-default`, {
            warehouseId,
            userId
        })
        return res
    }

    return {
        warehousesList,
        createWarehouse,
        updateWarehouse,
        deleteWarehouse,
        markWarehouseAsDefault
    }
}

export default warehouseApi
